import React, { useEffect, useState } from "react";
import { FaCloudUploadAlt } from "react-icons/fa";
import DisplayImage from "../DisplayImage";
import { MdDelete } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { toast } from "react-toastify";
import "../../css/Admin-Profile/ProfileDetails.css";
import Spinner from "../Spinner";

const ProfileDetails = () => {
  
    const [uploadProfileImage, setUploadProfileImage] = useState(0);
  const [uploadCV, setUploadCV] = useState(0);
  const [data, setData] = useState({
    githubLink: "",
    linkedinLink: "",
    facebookLink: "",
    whatsappNo: "",
    copyrightYear:"",
    cvLink: "",
    profileImage: [],
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const userProfileRef = doc(db, 'profile', 'userProfile');
        const docSnap = await getDoc(userProfileRef);

        if (docSnap.exists()) {
          const fetchedData = docSnap.data();
          console.log(fetchedData);
          setData({
            githubLink: fetchedData.githubLink || "",
            linkedinLink: fetchedData.linkedinLink || "",
            facebookLink: fetchedData.facebookLink || "",
            whatsappNo: fetchedData.whatsappNo || "",
            copyrightYear:fetchedData.copyrightYear || "",
            cvLink: fetchedData.cvLink || "",
            profileImage: fetchedData.profileImage || [],
          });
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

    fetchData();
  }, []);


  const [loading, setLoading] = useState(false);


  const [fullScreenImage, setFullScreenImage] = useState("");
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };

  async function handleUploadProfilePic(e) {
    setLoading(true);
    const image = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `$ProfileImage-${image.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Handle state changes such as progress, pause, and resume
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          setUploadProfileImage(progress);
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          reject(error);
          setLoading(false);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              profileImage: [...prev.profileImage, downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  async function handleUploadCV(e) {
    setLoading(true);
    const cv = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `$CV-${cv.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, cv);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Handle state changes such as progress, pause, and resume
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          setUploadCV(progress);
          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            case "running":
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          reject(error);
          setLoading(false);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            console.log(downloadURL);
            setData((prev) => ({
                ...prev,
                cvLink: downloadURL,
              }));
            console.log(data);
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }


  const handleDeleteProfileImage = (index) => {
    //console.log("clicl");
    const newLogos = [...data.profileImage];
    newLogos.splice(index, 1);
    setData((pre) => {
      return {
        ...pre,
        profileImage: [...newLogos],
      };
    });
  };
  const handleDeleteCV = (index) => {

    setData((pre) => {
      return {
        ...pre,
        cvLink: "",
      };
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const docRef = doc(db, "profile", "userProfile");
      await updateDoc(docRef, data);
      setLoading(false);
      toast.success("Profile Data Updated");
    } catch (error) {
      console.error("Error updating profile data:", error);
      setLoading(false);
      toast.error("Failed to update profile data");
    }
  };
  if (loading) {
    return <Spinner />;
  }

  return (
      <div className="edit-product-modal" style={{maxWidth: "800px"}}>
        <div className="modal-header">
          <h2 className="title" style={{textAlign:"center"}}>Edit Profile Settings</h2>
        </div>
        <form onSubmit={handleSubmit} style={{display:"flex",flexDirection:"column",gap:"10px",width:"100%"}}>
          <label htmlFor="githubLink">GitHub Link :</label>
          <input
            type="text"
            id="githubLink"
            placeholder="Enter GitHub Link"
            value={data.githubLink}
            name="githubLink"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="linkedinLink">Linkedin Link</label>
          <input
            type="text"
            id="linkedinLink"
            placeholder="Enter Linkedin Link"
            value={data.linkedinLink}
            name="linkedinLink"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="facebookLink">FaceBook Link:</label>
          <input
            type="text"
            className="input"
            placeholder="Enter the FaceBook Link"
            value={data.facebookLink}
            name="facebookLink"
            onChange={handleOnChange}
          />
          <label htmlFor="whatsappNo">WhatsappNo Link:</label>
          <input
            type="text"
            className="input"
            placeholder="Enter the whatsappNo Link"
            value={data.whatsappNo}
            name="whatsappNo"
            onChange={handleOnChange}
          />
          <label htmlFor="copyrightYear">Copyright Year:</label>
          <input
            type="text"
            className="input"
            placeholder="Enter the Copyright Year"
            value={data.copyrightYear}
            name="copyrightYear"
            onChange={handleOnChange}
          />
          <label htmlFor="profileImage" className="label">
          Profile Image :
          </label>
          <label htmlFor="profileImage">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Profile Image</p>
                <input
                  type="file"
                  id="profileImage"
                  className="hidden"
                  multiple={false}
                  onChange={handleUploadProfilePic}
                />
              </div>
            </div>
          </label>
          {uploadProfileImage > 0 && uploadProfileImage < 100 && (
            <label
              style={{ color: "blue", textAlign: "center" }}
            >{`Upload is ${uploadProfileImage}% done`}</label>
          )}

          <div>
            {data.profileImage.length > 0 ? (
              <div className="image-preview">
                {data.profileImage.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteProfileImage(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Profile Image</p>
            )}
          </div>

          <label htmlFor="cvLink" className="label">
            CV Link:
          </label>
          <label htmlFor="cvLink">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload CV</p>
                <input
                  type="file"
                  id="cvLink"
                  className="hidden"
                  onChange={handleUploadCV}
                />
              </div>
            </div>
          </label>
          {uploadCV > 0 &&
            uploadCV < 100 && (
              <label
                style={{ color: "blue", textAlign: "center" }}
              >{`Upload is ${uploadCV}% done`}</label>
            )}

          <div>
          
            {
            data.cvLink  ? (
                <label
                style={{ color: "blue", textAlign: "center" }}
              >{`CV Document Uploaded`}
              <div style={{width:"80px",height:"80px",backgroundColor:"green"}} className="cv-container">
                    
                    <div
                      className="delete-cv"
                      onClick={() => handleDeleteCV(data.cvLink.indexOf)}
                    >
                      <MdDelete />
                    </div>

              </div>
              
              </label>
              
            ) : (
              <p className="error-text">
                *Please Upload CV Document
              </p>
            )}
          </div>
          <button className="submit-button">Update Profile Data</button>
        </form>
        {openFullScreenImage && (
        <DisplayImage
          onClose={() => setOpenFullScreenImage(false)}
          imageUrl={fullScreenImage}
        />
      )}
      </div>
      

  );
};

export default ProfileDetails;
